module.exports = __webpack_public_path__ + "img/axs.e30a6e11.png";